import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {ServiceSchedulePage} from 'src/service-schedules/service-schedule-page'

export const Route = createFileRoute('/_app/projects/$projectId/schedules/$scheduleId')({
    component: ServiceScheduleRoute,
})

function ServiceScheduleRoute() {
    const {projectId, scheduleId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <ServiceSchedulePage projectId={projectId} scheduleId={scheduleId} />
        </Container>
    )
}
